import React, { useContext } from 'react';
import { getPath } from '@express-labs/raven-tools';
import MyAccount from './MyAccount';
import LogInState from './subcomponents/LogInState';
import { HeaderDynamicContext } from '../../../../contexts/HeaderDynamicData/HeaderDynamicData';
import getFromStorage from '../../../../helpers/storage/storage';
import { LOYALTY_BRANDING_CONFIGS } from '../../../../constants';

const fieldsToValidate = [
  'aList',
  'pointsBalance',
  'pointsToNextTier',
  'totalPointsForNextReward',
  'rewardsTotal',
];
const isValidCustomerDataFields = (customerData) => {
  const isValid = fieldsToValidate.every((field) => {
    const val = customerData[field];
    return typeof val !== 'undefined' && val !== null && val.toString().trim() !== '';
  });

  return (customerData.firstName || getFromStorage('firstName')) && isValid;
};

function MyAccountVM(props) {
  const LOYALTY_BRANDING_CONFIG = LOYALTY_BRANDING_CONFIGS.insiderConfig;
  const headerContext = useContext(HeaderDynamicContext);
  const { discount } = headerContext;
  const saveMoneyText = `Get an extra ${discount} off* your next purchase.`;
  const { loggedOut } = LOYALTY_BRANDING_CONFIG.hoverableSlideOutModal;
  const {
    containerClassName,
    creditCardName,
    iconCard,
    firstBtnPath,
    firstBtnTxt,
    firstPhrase,
    linkClassName,
    secondBtnPath,
    secondBtnTxt,
    secondPhrase,
    viewAccountText,
  } = loggedOut;
  const loyaltyWarmStateData = getFromStorage('loyaltyWarmStateData', {});
  const flagNewTiers = getPath(window, 'FLAGS.NewTiers', false);

  /**
   * Any one of the following condition must be statisfied inorder
   * to show loggedin user Account panel
   * 1)
   *  -> customer data must be present
   *  -> user is loggedin
   *  -> required customer data fields are valid
   * 2)
   *  -> `loyaltyWarmStateData` object is present in localstorage
   *  -> required fields are valid
   */
  if (
    (headerContext && Object.entries(headerContext?.customer).length > 0
      && headerContext?.customer.loginStatus === true
      && isValidCustomerDataFields(headerContext?.customer))
    || (Object.entries(loyaltyWarmStateData).length > 0
      && isValidCustomerDataFields(loyaltyWarmStateData))
  ) {
    return <LogInState {...props} />;
  }

  return (
    <MyAccount
      containerClassName={containerClassName}
      creditCardName={creditCardName}
      flagNewTiers={flagNewTiers}
      firstBtnPath={firstBtnPath}
      firstBtnTxt={firstBtnTxt}
      firstPhrase={firstPhrase}
      iconCard={iconCard}
      linkClassName={linkClassName}
      saveMoneyText={saveMoneyText}
      secondBtnPath={secondBtnPath}
      secondBtnTxt={secondBtnTxt}
      secondPhrase={secondPhrase}
      viewAccountText={viewAccountText}
      {...props}
    />
  );
}

export default MyAccountVM;
